const products = {
	add_button: "Produkt hinzufügen",
	alerts: {
		product_added: "Produkt <strong>{{name}}</strong> erfolgreich hinzugefügt!",
		product_edited: "Produkt <strong>{{name}}</strong> erfolgreich bearbeitet!",
	},
	delete_dialog: {
		description: "Möchten Sie das Produkt <strong>{{name}}</strong> löschen?",
		success_alert: "Löschen des Produkts war erfolgreich!",
		title: "Produkt löschen",
		unknown_alert: "Löschen des Produkts ist fehlgeschlagen! Bitte versuchen Sie es später erneut.",
	},
	errors: {
		invalid_price_calculation: "Ungültige Preisberechnung",
		invalid_test_formula_calculation:
			"Fehler: nicht alle Variablen sind eingegeben oder die Formel ist falsch",
		missing_required_variables:
			"Fehler: Die Variablen q und pr müssen in der Formel vorhanden sein.",
	},
	product_add: {
		form: {
			description: "Beschreibung",
			formula: "Formel",
			formula_check: "Verwendet eine Formel",
			formula_helper: `Die Werte 'q' (Menge) & 'pr' (Empfohlener Preis) sind obligatorische Werte. Sie müssen also in der Formel verwendet werden. Der Wert "pp" (Einkaufspreis) ist optional.

														<strong>Akzeptierte Operatoren sind:</strong>
															+ (hinzufügen.)
															- (subtrahieren.)
															* (multiplizieren)
															/ (dividieren)
															% (Modul)
															** (Exponent)
															() (Klammern zum Gruppieren von Ausdrücken)`,
			name_de: "Produktname (Deutsch)",
			name_en: "Produktname (Englisch)",
			name_nl: "Produktname",
			per: "Pro",
			price_purchase: "Einkaufspreis",
			price_recommended: "Empfohlener Preis",
			product_code: "Produktcode",
			product_code_invalid: "Kein HostFact-Produkt mit dem oben genannten Code gefunden",
			product_groups: "Produktgruppen",
			product_number: "HostFact Produktnummer",
			quantity: "Menge",
			test_your_formula: {
				price: "Preis",
				result: "Ergebnis:",
				title: "Testen Sie Ihre Formel:",
			},
			unit: "Einheit",
		},
		section_description: "Mit diesem Formular können Sie ein neues Produkt erstellen.",
		section_title: "Produkt hinzufügen",
		title: "Produkt hinzufügen",
	},
	product_edit: {
		section_description: "Mit diesem Formular können Sie das ausgewählte Produkt bearbeiten.",
		section_title: "Produkt bearbeiten",
		title: "Produkt bearbeiten",
	},
	table: {
		filters: {
			disabled: "Gelöschte Produkte anzeigen",
		},
		headers: {
			cost: "Kostenpreis",
			description: "Beschreibung",
			formula: "Formel",
			hostfact_number: "HostFact-Nummer",
			price: "Empfohlener Preis",
			product_code: "Produktcode",
			product_group: "Produktgruppe",
			product_name: "Produktname",
			sell_unit: "Verkaufseinheit",
		},
	},
	title: "Produkte",
};

export default products;
